// src/pages/Home/data/heroSlides.js

const heroSlides = [
  {
    id: "ecosysteme",
    eyebrow: "Applications conçues pour les clubs sportifs",
    title: "Simplifiez la gestion",
    highlightedTitle: "de votre club sportif.",
    description:
      "Clubs sportifs, associations, collectivités, comités et ligues : découvrez des outils pensés à partir des réalités du terrain.",
    image: "/images/home/hero-monappliclub.webp",
    imagePosition: "center",
    primaryAction: {
      label: "Découvrir les applications",
      to: "#products",
    },
    secondaryAction: {
      label: "Parler de mon projet",
      to: "#contact",
    },
    note: "Une gamme complète d’applications web",
  },
  {
    id: "monapplimairie",
    eyebrow: "MonAppliMairie",
    title: "Gérez votre site web communal",
    highlightedTitle: "en toute simplicité",
    description:
      "Un site web moderne et responsive, un agenda, des actualités, des formulaires et un annuaire : tout ce dont une mairie a besoin pour communiquer avec ses habitants.",
    image: "/images/home/hero-monapplimairie.webp",
    imagePosition: "center",
    primaryAction: {
      label: "Découvrir MonAppliMairie",
      to: "/product-monapplimairie",
    },
    secondaryAction: {
      label: "Demander une présentation",
      to: "#contact",
    },
    note: "Pour les mairies et collectivités",
  },
  {
    id: "instances",
    eyebrow: "Comités et ligues sportives",
    title: "Une plateforme à l’image",
    highlightedTitle: "de votre territoire.",
    description:
      "Calendrier, actualités, clubs, commissions, formations et documents : réunissez vos services dans une interface claire et moderne.",
    image: "/images/home/hero-instances.webp",
    imagePosition: "center",
    primaryAction: {
      label: "Voir les solutions",
      to: "#products",
    },
    secondaryAction: {
      label: "Me contacter",
      to: "#contact",
    },
    note: "Des solutions adaptées à chaque organisation",
  },
];

export default heroSlides;